// snapshot.* — snapshot lifecycle notifications.
//
// (protocol-events.md §1.1 / docs/_wip/undo-conflict-aware-2026-07-12.md
// 「設計確定 f4」節が正)
import { z } from 'zod';
/**
 * `snapshot.published` — s→c broadcast: a snapshot publish completed.
 *
 * Deliberately MINIMAL and TRANSIENT (f4, 2026-07-22 確定):
 * - carries no server stamps (`uid`/`seq`/`ts`) and is NOT appended to the
 *   session buffer or the stroke log — a client that misses it simply fails
 *   to advance its baseline until the next publish (≤ 5 min later) catches
 *   it up. No resume/replay handling exists or is needed.
 * - carries no snapshot URL: baselines advance by baking locally-held
 *   strokes, never by re-fetching the PNG (the presigned-URL TTL of 60s
 *   makes URLs useless in a broadcast anyway). The canonical recovery path
 *   for a client that lost its baseline is `room.resume` (snapshot mode).
 *
 * `snapshotSeq` is a WATERMARK, not a synchronous command: receivers may
 * bake lazily / time-sliced, and any rewind must be computed against the
 * baseline's ACTUAL baked watermark, not this broadcast value (bake rule:
 * only strokes with `endSeq <= snapshotSeq` AND not cancelled are baked).
 */
export const snapshotPublishedSchema = z.object({
    t: z.literal('snapshot.published'),
    snapshotSeq: z.number().int().nonnegative(),
});
//# sourceMappingURL=snapshot.js.map